import React, { useState, useEffect } from 'react';
import { getSubjects, addSubject, getClasses, getTeachers } from '../../api';
import { toast } from 'react-toastify';

const ManageSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '', code: '', class_id: '', teacher_id: '', credit_hours: 3
  });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [s, c, t] = await Promise.all([getSubjects(), getClasses(), getTeachers()]);
      setSubjects(s.data);
      setClasses(c.data);
      setTeachers(t.data);
    } catch (err) {
      toast.error('Error loading data');
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addSubject(formData);
      toast.success('Subject added!');
      setShowForm(false);
      setFormData({ name: '', code: '', class_id: '', teacher_id: '', credit_hours: 3 });
      loadData();
    } catch (err) {
      toast.error('Error adding subject');
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>Manage Subjects</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Add Subject
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Add New Subject</h4>
          <form onSubmit={handleAdd}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Subject Name</label>
                <input style={styles.input} placeholder="e.g. Physics"
                  value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})} required />
              </div>
              <div>
                <label style={styles.label}>Subject Code</label>
                <input style={styles.input} placeholder="e.g. PHY101"
                  value={formData.code}
                  onChange={e => setFormData({...formData, code: e.target.value})} />
              </div>
              <div>
                <label style={styles.label}>Class</label>
                <select style={styles.input} value={formData.class_id}
                  onChange={e => setFormData({...formData, class_id: e.target.value})} required>
                  <option value="">Select Class</option>
                  {classes.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.name} {c.section} - {c.group_name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Teacher</label>
                <select style={styles.input} value={formData.teacher_id}
                  onChange={e => setFormData({...formData, teacher_id: e.target.value})}>
                  <option value="">Select Teacher</option>
                  {teachers.map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Credit Hours</label>
                <input style={styles.input} type="number" min="1" max="6"
                  value={formData.credit_hours}
                  onChange={e => setFormData({...formData, credit_hours: e.target.value})} />
              </div>
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Save Subject</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.tableCard}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeader}>
              <th style={styles.th}>Subject Name</th>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Class</th>
              <th style={styles.th}>Teacher</th>
              <th style={styles.th}>Credit Hours</th>
            </tr>
          </thead>
          <tbody>
            {subjects.map(s => (
              <tr key={s.id} style={styles.tableRow}>
                <td style={styles.td}>{s.name}</td>
                <td style={styles.td}>{s.code || '-'}</td>
                <td style={styles.td}>{s.class_name || '-'}</td>
                <td style={styles.td}>{s.teacher_name || 'Not Assigned'}</td>
                <td style={styles.td}>{s.credit_hours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a3a5c', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a3a5c', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', marginTop: '5px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555' },
  btnGroup: { display: 'flex', gap: '10px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a3a5c' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
};

export default ManageSubjects;